<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/UTd1rX/tc-custom/9781680571134.jpg?1705292803203" alt="This image is the cover for the book X Marks the Spot"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">X Marks the Spot
      </h1>
      <p class="bookDescription body article font2">
        <p>Set sail on the high seas with this collection of 21 unforgettable short stories featuring dashing rogues, daring rebels, and wily pirates searching for treasures of all kinds, including a forgotten journal, a heavenly sword, a young girl’s lucky sock, and even the Fountain of Youth. Some pirates are familiar—complete with parrots, peg legs, and eye patches—but most are unique: a twelve-year-old computer hacker, a heroic rabbit on an unusual quest, a clump of cancer cells, and an alien setting sail among the stars. X Marks the Spot: An Anthology of Treasure and Theft is about those men and women who live on the fringes of society, who are beholden to no man, no law, and who always have one eye on the horizon. So grab your map and set your headings. There are adventures to be had, mateys, and treasures to be found. This anthology is the fifth volume produced by the alumni of the Superstars Writing Seminars, and all royalties benefit the Don Hodge Memorial Scholarship Fund.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lisa Magnum
      </h2>
      
      <p class="authorDescription body article">Lisa Mangum has worked in the publishing industry since 1997. She is currently the Managing Editor for Shadow Mountain Publishing and has worked with several New York Times best-selling authors. She is also the author of four national best-selling YA novels (The Hourglass Door trilogy and After Hello) as well as several short stories and novellas. She also wrote a nonfiction book about writing tips gleaned from the television show Supernatural. She edited One Horn to Rule Them All: A Purple Unicorn Anthology, A Game of Horns: A Red Unicorn Anthology, Dragon Writers: An Anthology, and Undercurrents: An Anthology of What Lies Beneath, also published by WordFire Press. She graduated with honors from the University of Utah, and currently lives in Taylorsville, Utah, with her husband, Tracy.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      WordFire Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6ea817c0